//React Related & Redux 
import React, { useState, useEffect, useRef } from 'react'
import axios from "axios"
//redux
import { useDispatch, useSelector } from 'react-redux'
import { detailproduct } from '../../redux/product/productActions'
import { addToCart } from '../../redux/cart/cartActions'
import { ADD_TO_CART_REQUEST_RESET } from '../../redux/cart/types'
import {
    listOfComments,
} from '../../redux/comment/commentsAction'
//MUI
import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import ButtonGroup from "@material-ui/core/ButtonGroup"
import Button from '@material-ui/core/Button'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import Snackbar from "@material-ui/core/Snackbar"
import MuiAlert from "@material-ui/lab/Alert"
import Rating from '@material-ui/lab/Rating'
import Collapse from '@material-ui/core/Collapse'
import Typography from '@material-ui/core/Typography'
import Hidden from '@material-ui/core/Hidden'
import Skeleton from "@material-ui/lab/Skeleton"
//Icons
import FindReplaceIcon from '@material-ui/icons/FindReplace'
import ZoomInIcon from '@material-ui/icons/ZoomIn'
import ZoomOutIcon from '@material-ui/icons/ZoomOut'
import BookmarkBorderIcon from '@material-ui/icons/BookmarkBorder'
import BookmarkIcon from '@material-ui/icons/Bookmark'
import ShareIcon from '@material-ui/icons/Share'
//Components
//My Components
import Dialog from "@material-ui/core/Dialog"
import Zoom from '@material-ui/core/Zoom'
import { isMobile } from "react-device-detect"
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch"
import ShareModal from "../../components/shareModal/index"
import WideLayout from "../../layouts/WideLayout"
import ProductCarousel from '../../components/Entities/Product/Carousel'
import * as TokenBaseFunc from "../../globalFuncs/TokenBaseActions"
import LoginModal from "../../components/LoginModal/Index"
import CommentArea from '../../components/Entities/Comment/CommentArea'
import CommentAreaAdmin from '../../components/Entities/Comment/CommentAreaAdmin'
import { PRODUCT_DETAILS_RESET } from '../../redux/product/productConstants'
import { COMMENTS_LIST_RESET } from '../../redux/comment/commentConstants'
import * as globalFuncs from '../../globalFuncs/Entities/Product/Index'
import * as TextLoader from "../../components/StaticTexts/Index"

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Zoom ref={ref} {...props} />;
})

const useStyles = makeStyles((theme) => ({
    closeIcon: {
        cursor: 'pointer'
    },
    grayBox: {
        backgroundColor: '#f2f2f2',
        [theme.breakpoints.down("sm")]: {
            paddingTop: theme.spacing(2),
            paddingRight: theme.spacing(1),
            paddingLeft: theme.spacing(1),
            paddingBottom: theme.spacing(1)
        },
        [theme.breakpoints.up("sm")]: {
            padding: theme.spacing(4)
        },
    },
    red: {
        color: '#950000',

    },
    avatarIcon: {
        width: '1.5em !important',
        height: '1.5em !important',
    },
    paperNoBg: {
        backgroundColor: 'transparent',
    },
    noBgAndShdaw: {
        backgroundColor: 'transparent',
        boxShadow: 'none',
        border: 'none',
    },
    imgContiner: {
        backgroundColor: 'transparent',
        boxShadow: 'none',
        border: 'none',
        textAlign: 'center'
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'right',
        color: theme.palette.text.secondary,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
        width: '150px',
        backgroundColor: '#f5f5f5',
        borderRadius: '8px',
        border: '1px #3d3d3d solid',
        height: '40px',
        marginTop: '0px',
        paddingRight: '10px !important',
    },
    root: {
        display: 'flex',
    },
    whiteBox: {
        backgroundColor: "#ffffff",
    },
    productCarousel: {
        backgroundColor: '#f2f2f2',
        [theme.breakpoints.up("sm")]: {
            padding: '40px',
            marginLeft: '40px',
            marginRight: '40px'
        },
        [theme.breakpoints.down("sm")]: {
            padding: '50px 5px 40px 5px',
            marginLeft: '4px',
            marginRight: '4px'
        },
    },
    buyButton: {
        display: 'block',
        marginTop: '40px',
        width: '100%',
        backgroundColor: '#28a504',
        fontWeight: '700',
        '&:hover': {
            backgroundColor: "#417557",
        },
    },
    productTitle: {
        [theme.breakpoints.up("sm")]: {
            fontSize: '1.2rem',
            fontWeight: '700',
            marginBottom: '30px'
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: '0.8rem',
            fontWeight: '700',
            marginTop: '15px',
            marginBottom: '15px',
            marginRight: '14px',
        }
    },
    price: {
        [theme.breakpoints.up("sm")]: {
            fontSize: '1.2rem',
            fontWeight: '700',
            color: '#950000'
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: '0.8rem',
            fontWeight: '700',
            color: '#950000',
            marginRight: '14px',
            marginBottom: '15px',
        }
    },
    selectWeight: {
        [theme.breakpoints.up("sm")]: {
            fontSize: '1rem',
            marginTop: '30px',
            marginBottom: '5px'
        },
        [theme.breakpoints.down("md")]: {
            fontSize: '0.900rem',
            marginBottom: '10px',
        }
    },
    ratingBox: {
        [theme.breakpoints.up("sm")]: {
            textAlign: 'left'
        },
        [theme.breakpoints.down("md")]: {
            textAlign: 'right',
            paddingRight: '12px',
        }
    },
    propTitle: {
        [theme.breakpoints.up("sm")]: {
            fontSize: '1.2rem',
            fontWeight: '700',
            marginBottom: '15px',
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: '1rem',
            fontWeight: '700',
            marginBottom: '15px',
            marginTop: '10px',
        }
    },
    propContent: {
        [theme.breakpoints.up("sm")]: {
            fontSize: '0.950rem',
            marginTop: '20px',
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: '0.850rem',
            marginTop: '20px',
        }
    },
    boxRight: {
        [theme.breakpoints.up("sm")]: {
            borderLeft: '1px #ccc solid',
            paddingLeft: '30px',
        },
        [theme.breakpoints.down("sm")]: {
            paddingLeft: '0px'
        }
    },
    properties: {
        [theme.breakpoints.up("sm")]: {
            margin: '0px 25px 0px 25px',
        },
        [theme.breakpoints.down("sm")]: {
            margin: '30px 0px 20px 0px',
        },
    },
    newestBox: {
        [theme.breakpoints.up("sm")]: {
            marginTop: '45px'
        },
        [theme.breakpoints.down("xs")]: {
            marginTop: '45px'
        },
    },
    bookmarkbar: {
        textAlign: 'left',
        [theme.breakpoints.up("sm")]: {
            marginTop: '24px'
        },
        [theme.breakpoints.down("sm")]: {
            marginTop: '0px'
        },
    },
    btnAddBookmark: {
        backgroundColor: "transparent",
        boxShadow: 'none !important',
        border: 'none',
        padding: '0px !important',
        '&:hover': {
            backgroundColor: "transparent",
        },
        '&:focus': {
            backgroundColor: "transparent",
        },
    },
    counterBox: {
        [theme.breakpoints.up("sm")]: {
            textAlign: 'left',
            marginTop: '24px',
        },
        [theme.breakpoints.down("sm")]: {
            textAlign: 'left',
            marginTop: '25px',
        },
    },
    circleLoading: {
        [theme.breakpoints.up("sm")]: {
            width: '97%',
            minHeight: '416px',
            position: 'relative',
            borderRadius: '50%',
            top: '10px',
            marginTop: '-108px',
        },
        [theme.breakpoints.down("sm")]: {
            width: '97%',
        },
    },
}))

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const numberLoader = [1, 2, 3, 4, 5];

const Product = ({ location, history, match, lang }) => {

    //MUI Classes
    const classes = useStyles()
    const textInputRef = useRef(null)

    //consts openShareModal
    const [openShareModal, setOpenShareModal] = useState(false)
    const [addToCartIsDisabled, setAddToCartIsDisabled] = useState(true)
    const [showOutOfStockMSG, setShowOutOfStockMSG] = React.useState(true)
    const [outOfStock250, setOutOfStock250] = React.useState(true)
    const [outOfStock500, setOutOfStock500] = React.useState(true)
    const [outOfStock1000, setOutOfStock1000] = React.useState(true)
    const [productCount, setProductCount] = React.useState(1)
    const [totalPrice, setTotalPrice] = useState('')
    const [selectedWeight, setSelectedWeight] = React.useState('0')
    const [btnPlusDisabled, setBtnPlusDisabled] = React.useState(false)
    const [btnMinesDisabled, setBtnMinesDisabled] = React.useState(true)
    const [productDetail, setProductDetail] = useState({
        id: 0,
        thumbnailImgURL: '',
        imgURL: '',
        title: '',
        price250: 0,
        price500: 0,
        price1000: 0,
        starRating: 0,
        bookmarked: false,
        numberInStock250: 0,
        numberInStock500: 0,
        numberInStock1000: 0,
        propertiesTitle: '',
        propertiesText: '',
        bulkSale: false,
    })
    const [userInfo, setUserInfo] = useState([])
    const [loggedIn, setLoggedIn] = useState(false)
    const [itemID, setItemID] = useState(match.params.pid)
    const [bookmarking, setBookmarking] = React.useState(false)
    const [productBookmarked, setProductBookmarked] = React.useState(false)
    const [isModalOpen, setIsModalOpen] = React.useState(false)
    const [showRelated, setShowRelated] = useState(false)
    const [breadcrumbsItems, setBreadcrumbsItems] = useState([])
    const [staticText, setStaticText] = useState({})
    const [haveSharp, setHaveSharp] = useState(false)
    const [open, setOpen] = React.useState(false)
    const [alert, setAlert] = useState({
        open: false,
        type: "success",
        message: "",
    })

    //Redux
    const dispatch = useDispatch()
    const pageData = useSelector(state => state.productDetails)

    const {
        loading,
        error,
        relatedProducts,
    } = pageData
    const commentsListState = useSelector(state => state.commentsList)
    const {
        cLoading,
        cError,
        comments,
        totalPages,
    } = commentsListState

    useEffect(() => {
        if (!loading && !error && typeof pageData.id !== 'undefined') {
            setProductDetail({
                id: pageData.id,
                thumbnailImgURL: pageData.thumbnailImgURL,
                imgURL: pageData.imgURL,
                title: pageData.title,
                price250: pageData.price250,
                price500: pageData.price500,
                price1000: pageData.price1000,
                starRating: pageData.starRating,
                bookmarked: pageData.bookmarked,
                numberInStock250: pageData.numberInStock250,
                numberInStock500: pageData.numberInStock500,
                numberInStock1000: pageData.numberInStock1000,
                propertiesTitle: pageData.propertiesTitle,
                propertiesText: pageData.propertiesText,
                bulkSale: pageData.bulkSale,
            })
            setProductBookmarked(pageData.bookmarked)
            if ((Number(pageData.numberInStock250) !== 0) || (Number(pageData.numberInStock500) !== 0) || (Number(pageData.numberInStock1000) !== 0)) {
                setShowOutOfStockMSG(false)
                setAddToCartIsDisabled(false)
            }
            if ((Number(pageData.price250) !== 0) && (Number(pageData.numberInStock250) !== 0)) {
                setSelectedWeight('1')
                setTotalPrice(getDefaultPrice(pageData, 1))
                setOutOfStock250(false)
            }
            if (pageData.bulkSale) {
                if ((Number(pageData.price500) !== 0) && (Number(pageData.numberInStock500) !== 0)) {
                    setOutOfStock500(false)
                    if (Number(pageData.numberInStock250) === 0) {
                        setSelectedWeight('2')
                        setTotalPrice(getDefaultPrice(pageData, 2))
                    }
                }
                if ((Number(pageData.price1000) !== 0) && (Number(pageData.numberInStock1000) !== 0)) {
                    setOutOfStock1000(false)
                    if (Number(pageData.numberInStock250) === 0 && Number(pageData.numberInStock500) === 0) {
                        setSelectedWeight('4')
                        setTotalPrice(getDefaultPrice(pageData, 4))
                    }
                }
            }
        }
    }, [pageData])


    //Cart Code
    const reduxCartState = useSelector(state => state.cart)
    useEffect(() => {
        if (typeof reduxCartState.reduxCartActionResult !== 'undefined' && reduxCartState.reduxCartActionResult !== null) {
            toggleOpenAlert(reduxCartState.reduxCartActionResult.error ? 'error' : 'success', reduxCartState.reduxCartActionResult.message)
            dispatch({ type: ADD_TO_CART_REQUEST_RESET })
        }
    }, [reduxCartState])

    const handleAddtoCart = (count, weight) => {
        if (!addToCartIsDisabled) {
            dispatch(addToCart(productDetail, count, weight))
        }
    }

    const onOpenShareModal = () => setOpenShareModal(true)

    const onCloseShareModal = () => setOpenShareModal(false)

    const onClose = () => {
        setIsModalOpen(false)
    }

    const refreshComment = () => {
        var il = TokenBaseFunc.TokenStatus()
        var ui = []
        if (il) {
            setLoggedIn(true)
            ui = TokenBaseFunc.ReturnUserInfos()
            setUserInfo(ui)
        }
        if (il) {
            dispatch(listOfComments(
                "products",
                itemID,
                1,
                ui.im,
                ui.token,
            ))
        }
        else {
            dispatch(listOfComments(
                "products",
                itemID,
                1,
                false,
                ''
            ))
        }
    }

    const handleClickOpen = () => {
        setOpen(true)
    };

    const handleClose = () => {
        setOpen(false)
    };

    const toggleCloseAlert = () => {
        setAlert({ open: false, type: alert.type, message: alert.message })
    };

    const toggleOpenAlert = (Type, msg) => {
        setAlert({
            open: true,
            type: Type,
            message: msg,
        })
    };

    const openModal = () => {
        setIsModalOpen(true)
    }

    const resetInfo = () => {
        dispatch({ type: PRODUCT_DETAILS_RESET })
        dispatch({ type: COMMENTS_LIST_RESET })
        setShowOutOfStockMSG(false)
        setAddToCartIsDisabled(true)
        setProductCount(1)
        setTotalPrice('')
        setSelectedWeight('0')
        setBtnPlusDisabled(false)
        setBtnMinesDisabled(true)
    }

    const getDefaultPrice = (data, packageWeight, seprate = true) => {
        let price = 0
        if (packageWeight === 1) {
            price = Number(data.price250)
        }
        else if (packageWeight === 2) {
            price = Number(data.price500)
        }
        else if (packageWeight === 4) {
            price = Number(data.price1000)
        }
        if (!seprate)
            return price
        else
            return globalFuncs.SepratePrice(price.toString())
    }

    const getPrice = (packageWeight, seprate = true) => {
        let price = 0
        if (packageWeight === 1) {
            price = Number(productDetail.price250)
        }
        else if (packageWeight === 2) {
            price = Number(productDetail.price500)
        }
        else if (packageWeight === 4) {
            price = Number(productDetail.price1000)
        }
        if (!seprate)
            return price
        else
            return globalFuncs.SepratePrice(price.toString())
    }

    const handleAddBookmark = async (pID) => {

        setBookmarking(true)
        if (TokenBaseFunc.TokenStatus()) {
            try {
                var formData = new FormData()
                formData.append('ProductId', pID)
                const { data } = await axios.post("/api/products/bookmarks/add", formData, {
                    headers: {
                        Authorization: `Bearer ` + localStorage.getItem("token"),
                        "content-type": "multipart/form-data",
                    },
                })
                if (data.status === "ok") {
                    setProductBookmarked(true)
                }
            } catch (error) {

            }
        }
        else {
            openModal()
        }
        setBookmarking(false)

    };

    useEffect(() => {

        var isSharp = false
        if (window.location.hash) {
            setHaveSharp(true)
            isSharp = true
        }

        window.scrollTo(0, 0)
        var il = TokenBaseFunc.TokenStatus()
        var ui = []
        if (il) {
            setLoggedIn(true)
            ui = TokenBaseFunc.ReturnUserInfos()
            setUserInfo(ui)
        }

        dispatch(detailproduct(
            lang,
            match.params.pid,
        ))
        // .then(() => {
        //     if (typeof bookmarked !== 'undefined') {
        //         setProductBookmarked(bookmarked)
        //     }
        // })

        if (il) {
            dispatch(listOfComments(
                "products",
                match.params.pid,
                1,
                ui.im,
                ui.token,
            ))
        }
        else {
            dispatch(listOfComments(
                "products",
                match.params.pid,
                1,
                false,
                ''
            ))
        }

        setStaticText(TextLoader.staticTextLoader("productDetail", lang))
        if (lang === 'fa') {
            setBreadcrumbsItems([
                {
                    title: 'صفحه اصلی',
                    to: "/"
                },
                {
                    title: 'لیست محصولات',
                    to: "/products"
                },
                {
                    title: 'جزئیات محصول',
                    to: "/"
                }
            ])
        }
        else {
            setBreadcrumbsItems([
                {
                    title: 'الصفحة الأصلية',
                    to: "/"
                },
                {
                    title: 'منتجات',
                    to: "/products"
                },
                {
                    title: 'تفاصيل المنتج',
                    to: "/"
                }
            ])
        }

        return history.listen((location) => {
            if (window.location.hash) {
                setHaveSharp(true)
                isSharp = true
            }
            if (!isSharp) {
                resetInfo()
                var loc = location.pathname
                if (loc.includes("/product/")) {

                    var res = loc.split("/")
                    var prID = 0;
                    if (res.length === 3 && !isNaN(res[2])) {

                        prID = res[2]
                        setItemID(prID)

                        var ili = TokenBaseFunc.TokenStatus()
                        var uinfo = []
                        if (ili) {
                            setLoggedIn(true)
                            uinfo = TokenBaseFunc.ReturnUserInfos()
                            setUserInfo(uinfo)
                        }

                        dispatch(detailproduct(
                            lang,
                            prID,
                        ))
                        // .then(() => {
                        //     if (typeof bookmarked !== 'undefined') {
                        //         setProductBookmarked(bookmarked)
                        //     }
                        // })

                        if (il) {
                            dispatch(listOfComments(
                                "products",
                                prID,
                                1,
                                ui.im,
                                ui.token,
                            ))
                        }
                        else {
                            dispatch(listOfComments(
                                "products",
                                prID,
                                1,
                                false,
                                ''
                            ))
                        }

                    }

                    window.scrollTo(0, 0)

                }
            }
        })

    }, [])

    useEffect(() => {
        return () => {
            resetInfo()
        }
    }, [])

    return (

        <WideLayout lang={lang} breadcrumbsItems={breadcrumbsItems} title={productDetail.title} description={productDetail.propertiesText} >

            <Grid item md={12}>

                <Box boxShadow={1} borderColor='#f2f2f2' border={1} borderRadius={16} className={classes.grayBox}>
                    <Grid container>
                        <Grid item xs={12} md={7}>
                            <Grid container>
                                <Grid item md={5} xs={5}>
                                    <Paper className={classes.imgContiner}>
                                        <Box evelotion={0} style={{ padding: '0px 10px 0px 10px', direction: 'ltr' }} dir="ltr">
                                            {loading ? (
                                                <Skeleton animation="wave" className={classes.circleLoading} />
                                            ) : (
                                                <a style={{ cursor: 'pointer' }} onClick={handleClickOpen}><img src={productDetail.thumbnailImgURL} alt={productDetail.title} style={{ maxWidth: '100%', margin: '10px auto 10px auto' }} /></a>
                                            )}
                                        </Box>
                                    </Paper>
                                </Grid>
                                <Grid item md={7} xs={7} className={classes.boxRight + ' detail'}>
                                    <Box evelotion={0} m={1}>
                                        <Grid container>
                                            <Hidden only={['lg', 'md', 'sm']}>
                                                <Grid item xs={12} className="graySvg largSvg">
                                                    <Paper className={classes.noBgAndShdaw}>
                                                        <Box evelotion={0} className={classes.bookmarkbar}>
                                                            {(loading) ? (
                                                                <>
                                                                    <BookmarkIcon style={{ fill: "#e3e3e3" }} />
                                                                    <ShareIcon className="mr5" style={{ fill: "#e3e3e3" }} />
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <BookmarkIcon style={{ display: (productBookmarked) ? 'inline-block' : 'none' }} />
                                                                    <Button style={{ top: '-11px', lineHeight: '1rem', minWidth: '38px', marginLeft: '7px', display: (productBookmarked) ? 'none' : 'inline-block' }} className={classes.btnAddBookmark} disabled={bookmarking} onClick={() => { handleAddBookmark(`${productDetail.id}`) }}><BookmarkBorderIcon /></Button>
                                                                    <ShareIcon style={{ cursor: "pointer" }} className="mr5" onClick={() => onOpenShareModal()} />
                                                                </>
                                                            )}
                                                        </Box>
                                                    </Paper>
                                                </Grid>
                                            </Hidden>
                                            <Grid item md={9} sm={9} xs={12}>
                                                <Paper className={classes.noBgAndShdaw}>
                                                    <Box evelotion={0}>
                                                        {(loading) ? (
                                                            <Skeleton animation="wave" style={{ height: '45px' }} />
                                                        ) : (
                                                            <Typography variant="h1" style={{ marginTop: '0px' }} className={classes.productTitle}>
                                                                {productDetail.title}
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                </Paper>
                                            </Grid>
                                            <Hidden only={['xs']}>
                                                <Grid item md={3} sm={3} className="graySvg largSvg">
                                                    <Paper className={classes.noBgAndShdaw}>
                                                        <Box evelotion={0} style={{ textAlign: 'left' }}>
                                                            {(loading) ? (
                                                                <>
                                                                    <BookmarkIcon style={{ fill: "#e3e3e3" }} />
                                                                    <ShareIcon className="mr5" style={{ fill: "#e3e3e3" }} />
                                                                </>
                                                            ) : (
                                                                <>

                                                                    <BookmarkIcon style={{ display: (productBookmarked) ? 'inline-block' : 'none' }} />
                                                                    <Button style={{ top: '-11px', lineHeight: '1rem', minWidth: '38px', marginLeft: '7px', display: (productBookmarked) ? 'none' : 'inline-block' }} className={classes.btnAddBookmark} disabled={bookmarking} onClick={() => { handleAddBookmark(`${productDetail.id}`) }}><BookmarkBorderIcon /></Button>
                                                                    <ShareIcon className="mr5" style={{ cursor: "pointer" }} onClick={() => onOpenShareModal()} />
                                                                </>
                                                            )}
                                                        </Box>
                                                    </Paper>
                                                </Grid>
                                            </Hidden>
                                            <Grid item md={5} sm={5} xs={12}>
                                                <Paper className={classes.noBgAndShdaw}>
                                                    <Box evelotion={0} style={{ textAlign: 'right' }}>
                                                        {(loading) ? (
                                                            <>
                                                                <Skeleton animation="wave" style={{ height: '33px', width: '100px' }} />
                                                            </>
                                                        ) : (
                                                            (showOutOfStockMSG) ? (
                                                                <span className="outOfStockBadge">{staticText.outOfStockSelectedWeight}</span>
                                                            ) : (
                                                                <>
                                                                    <Collapse in={showOutOfStockMSG}>
                                                                        <span className="outOfStockBadge">{staticText.outOfStockSelectedWeight}</span>
                                                                    </Collapse>
                                                                    <Collapse in={!showOutOfStockMSG}>
                                                                        <Typography variant="h2" className={classes.price} ref={textInputRef}>
                                                                            {totalPrice}
                                                                        </Typography>
                                                                    </Collapse>
                                                                </>
                                                            )
                                                        )}
                                                    </Box>
                                                </Paper>
                                            </Grid>
                                            <Grid item md={7} sm={7} xs={12}>
                                                <Paper className={classes.noBgAndShdaw} style={{ textAlign: 'left' }}>
                                                    <Box evelotion={0} className={classes.ratingBox}>
                                                        <Rating
                                                            name="simple-controlled2"
                                                            value={productDetail.starRating}
                                                            disabled
                                                        />
                                                    </Box>
                                                </Paper>
                                            </Grid>
                                            <Hidden only={['xs']}>
                                                {(loading) ? (
                                                    <>
                                                        <Grid item xs={6}>
                                                            {(productDetail.bulkSale) && (
                                                                <Paper className={classes.noBgAndShdaw}>
                                                                    <Box evelotion={0} style={{ textAlign: 'right' }}>

                                                                        <Typography variant="h2" className={classes.selectWeight}>
                                                                            {staticText.selectWeight}
                                                                        </Typography>
                                                                        <Select
                                                                            value={'1'}
                                                                            displayEmpty
                                                                            disabled={true}
                                                                            className={classes.selectEmpty}
                                                                            inputProps={{ 'aria-label': 'Without label' }}>
                                                                            <MenuItem value="0">
                                                                                <em>{staticText.selectWeight}</em>
                                                                            </MenuItem>
                                                                            <MenuItem value={'1'}>{staticText.package1Title}</MenuItem>
                                                                            <MenuItem value={'2'}>{staticText.package2Title}</MenuItem>
                                                                            <MenuItem value={'4'}>{staticText.package3Title}</MenuItem>
                                                                        </Select>

                                                                    </Box>
                                                                </Paper>
                                                            )}
                                                        </Grid>
                                                        <Grid item md={6} sm={6}>
                                                            <Paper className={classes.noBgAndShdaw}>
                                                                <Box evelotion={0} mt={7} style={{ textAlign: 'left' }}>
                                                                    <Collapse in={!showOutOfStockMSG}>
                                                                        <ButtonGroup className="counterBtns" size="small" aria-label="small outlined button group">
                                                                            <Button disabled={true}>+</Button>
                                                                            <Button disabled={true} style={{ marginLeft: '5px', marginRight: '5px' }}>{productCount}</Button>
                                                                            <Button disabled={true}>-</Button>
                                                                        </ButtonGroup>
                                                                    </Collapse>
                                                                </Box>
                                                            </Paper>
                                                        </Grid>

                                                        {(lang === 'fa') &&

                                                            <Grid item md={12}>
                                                                <Paper className={classes.noBgAndShdaw}>
                                                                    <Box evelotion={0}>
                                                                        <Button type="button" disabled={true} variant="contained" color="primary" className={classes.buyButton + ' mt35'}>افزودن به سبد خرید</Button>
                                                                    </Box>
                                                                </Paper>
                                                            </Grid>

                                                        }
                                                    </>
                                                ) : (
                                                    <>
                                                        {(showOutOfStockMSG) ? (
                                                            <>
                                                                <Grid item xs={6}>
                                                                    <Paper className={classes.noBgAndShdaw}>
                                                                        <Box evelotion={0} style={{ textAlign: 'right' }}>
                                                                            <Typography variant="h2" className={classes.selectWeight}>
                                                                                {staticText.selectWeight}
                                                                            </Typography>
                                                                            <Select
                                                                                value={'1'}
                                                                                displayEmpty
                                                                                disabled={true}
                                                                                className={classes.selectEmpty}
                                                                                inputProps={{ 'aria-label': 'Without label' }}>
                                                                                <MenuItem value="0">
                                                                                    <em>{staticText.selectWeight}</em>
                                                                                </MenuItem>
                                                                                <MenuItem value={'1'}>{staticText.package1Title}</MenuItem>
                                                                                <MenuItem value={'2'}>{staticText.package2Title}</MenuItem>
                                                                                <MenuItem value={'4'}>{staticText.package3Title}</MenuItem>
                                                                            </Select>
                                                                        </Box>
                                                                    </Paper>
                                                                </Grid>
                                                                <Grid item md={6} sm={6}>
                                                                    <Paper className={classes.noBgAndShdaw}>
                                                                        <Box evelotion={0} mt={7} style={{ textAlign: 'left' }}>
                                                                            <Collapse in={!showOutOfStockMSG}>
                                                                                <ButtonGroup className="counterBtns" size="small" aria-label="small outlined button group">
                                                                                    <Button disabled={true}>+</Button>
                                                                                    <Button disabled={true} style={{ marginLeft: '5px', marginRight: '5px' }}>{productCount}</Button>
                                                                                    <Button disabled={true}>-</Button>
                                                                                </ButtonGroup>
                                                                            </Collapse>
                                                                        </Box>
                                                                    </Paper>
                                                                </Grid>

                                                                {(lang === 'fa') &&

                                                                    <Grid item md={12}>
                                                                        <Paper className={classes.noBgAndShdaw}>
                                                                            <Box evelotion={0}>
                                                                                <Button type="button" disabled={true} variant="contained" color="primary" className={classes.buyButton + ' mt35'}>افزودن به سبد خرید</Button>
                                                                            </Box>
                                                                        </Paper>
                                                                    </Grid>

                                                                }
                                                            </>
                                                        ) : (
                                                            <>
                                                                <Grid item xs={6}>
                                                                    {(productDetail.bulkSale) && (
                                                                        <Paper className={classes.noBgAndShdaw}>
                                                                            <Box evelotion={0} style={{ textAlign: 'right' }}>
                                                                                <Typography variant="h2" className={classes.selectWeight}>
                                                                                    {staticText.selectWeight}
                                                                                </Typography>
                                                                                <Select
                                                                                    value={selectedWeight}
                                                                                    onChange={
                                                                                        (event) => {
                                                                                            if (!loading) {
                                                                                                setSelectedWeight(event.target.value)
                                                                                                if (Number(event.target.value) === 1) {
                                                                                                    if (Number(productDetail.numberInStock250) === 0) {
                                                                                                        setShowOutOfStockMSG(true)
                                                                                                    }
                                                                                                    else {
                                                                                                        setShowOutOfStockMSG(false)
                                                                                                        setBtnPlusDisabled(false)
                                                                                                        setBtnMinesDisabled(true)
                                                                                                        setProductCount(1)
                                                                                                        setTotalPrice(getPrice(1))
                                                                                                    }
                                                                                                }
                                                                                                else if (Number(event.target.value) === 2) {
                                                                                                    if (Number(productDetail.numberInStock500) === 0) {
                                                                                                        setShowOutOfStockMSG(true)
                                                                                                    }
                                                                                                    else {
                                                                                                        setShowOutOfStockMSG(false)
                                                                                                        setBtnPlusDisabled(false)
                                                                                                        setBtnMinesDisabled(true)
                                                                                                        setProductCount(1)
                                                                                                        setTotalPrice(getPrice(2))
                                                                                                    }
                                                                                                }
                                                                                                else if (Number(event.target.value) === 4) {
                                                                                                    if (Number(productDetail.numberInStock1000) === 0) {
                                                                                                        setShowOutOfStockMSG(true)
                                                                                                    }
                                                                                                    else {
                                                                                                        setBtnPlusDisabled(false)
                                                                                                        setBtnMinesDisabled(true)
                                                                                                        setShowOutOfStockMSG(false)
                                                                                                        setProductCount(1)
                                                                                                        setTotalPrice(getPrice(4))
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                    displayEmpty
                                                                                    disabled={loading}
                                                                                    className={classes.selectEmpty}
                                                                                    inputProps={{ 'aria-label': 'Without label' }}>
                                                                                    <MenuItem value="0">
                                                                                        <em>{staticText.selectWeight}</em>
                                                                                    </MenuItem>
                                                                                    <MenuItem value={'1'} disabled={outOfStock250}>{staticText.package1Title} {outOfStock250 && '(ناموجود)'}</MenuItem>
                                                                                    <MenuItem value={'2'} disabled={outOfStock500}>{staticText.package2Title} {outOfStock500 && '(ناموجود)'}</MenuItem>
                                                                                    <MenuItem value={'4'} disabled={outOfStock1000}>{staticText.package3Title} {outOfStock1000 && '(ناموجود)'}</MenuItem>
                                                                                </Select>
                                                                            </Box>
                                                                        </Paper>
                                                                    )}
                                                                </Grid>
                                                                <Grid item md={6} sm={6}>
                                                                    <Paper className={classes.noBgAndShdaw}>
                                                                        <Box evelotion={0} mt={7} style={{ textAlign: 'left' }}>
                                                                            <Collapse in={!showOutOfStockMSG}>
                                                                                <ButtonGroup className="counterBtns" size="small" aria-label="small outlined button group">
                                                                                    <Button disabled={(loading) ? true : btnPlusDisabled} onClick={() => {

                                                                                        if (Number(selectedWeight) === 1) {
                                                                                            if ((productCount + 1) <= productDetail.numberInStock250) {
                                                                                                setTotalPrice(globalFuncs.SepratePrice(getPrice(1, false) * (productCount + 1)))
                                                                                                setProductCount(productCount + 1)
                                                                                                setBtnMinesDisabled(false)
                                                                                            }
                                                                                            else
                                                                                                setBtnPlusDisabled(true)
                                                                                        }
                                                                                        else if (Number(selectedWeight) === 2) {
                                                                                            if ((productCount + 1) <= productDetail.numberInStock500) {
                                                                                                setTotalPrice(globalFuncs.SepratePrice(getPrice(2, false) * (productCount + 1)))
                                                                                                setProductCount(productCount + 1)
                                                                                                setBtnMinesDisabled(false)
                                                                                            }
                                                                                            else
                                                                                                setBtnPlusDisabled(true)
                                                                                        }
                                                                                        else if (Number(selectedWeight) === 4) {
                                                                                            if ((productCount + 1) <= productDetail.numberInStock1000) {
                                                                                                setTotalPrice(globalFuncs.SepratePrice(getPrice(4, false) * (productCount + 1)))
                                                                                                setProductCount(productCount + 1)
                                                                                                setBtnMinesDisabled(false)
                                                                                            }
                                                                                            else
                                                                                                setBtnPlusDisabled(true)
                                                                                        }

                                                                                    }}>+</Button>
                                                                                    <Button disabled={false} style={{ marginLeft: '5px', marginRight: '5px' }}>{productCount}</Button>
                                                                                    <Button disabled={(loading) ? true : btnMinesDisabled} onClick={() => {
                                                                                        if ((productCount - 1) > 0) {
                                                                                            setTotalPrice(globalFuncs.SepratePrice(getPrice(Number(selectedWeight), false) * (productCount - 1)))
                                                                                            setProductCount(productCount - 1)
                                                                                            setBtnPlusDisabled(false)
                                                                                        }
                                                                                        else
                                                                                            setBtnMinesDisabled(true)
                                                                                    }}>-</Button>
                                                                                </ButtonGroup>
                                                                            </Collapse>


                                                                        </Box>
                                                                    </Paper>
                                                                </Grid>
                                                                {(lang === 'fa') &&
                                                                    <Grid item md={12}>
                                                                        <Paper className={classes.noBgAndShdaw}>
                                                                            <Box evelotion={0}>
                                                                                {(loading) ? (
                                                                                    <Button type="button" disabled={true} variant="contained" color="primary" className={classes.buyButton + ' mt35'}>افزودن به سبد خرید</Button>
                                                                                ) : (
                                                                                    <>
                                                                                        <Button type="button" style={{ display: (showOutOfStockMSG) ? 'none' : 'block' }} disabled={addToCartIsDisabled} variant="contained" color="primary" onClick={() => { handleAddtoCart(productCount, selectedWeight) }} className={classes.buyButton + ' mt35'}>افزودن به سبد خرید</Button>
                                                                                        <Button type="button" style={{ display: (!showOutOfStockMSG) ? 'none' : 'block' }} disabled={true} variant="contained" color="primary" className={classes.buyButton + ' mt35'}>افزودن به سبد خرید</Button>
                                                                                    </>
                                                                                )}

                                                                            </Box>
                                                                        </Paper>
                                                                    </Grid>
                                                                }
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                            </Hidden>
                                        </Grid>
                                    </Box>
                                </Grid>
                                <Hidden only={['xl', 'lg', 'md', 'sm']}>
                                    {(loading) ? (
                                        <>
                                            <Grid item xs={6}>
                                                {(productDetail.bulkSale) && (
                                                    <Paper evelotion={0} className={classes.noBgAndShdaw}>
                                                        <Box evelotion={0}>
                                                            <Typography variant="h2" className={classes.selectWeight}>
                                                                {staticText.selectWeight}

                                                            </Typography>
                                                            <Select
                                                                value={'4'}
                                                                disabled={true}
                                                                displayEmpty
                                                                className={classes.selectEmpty}
                                                                inputProps={{ 'aria-label': 'Without label' }}>
                                                                <MenuItem value={0}>
                                                                    <em>{staticText.selectWeight}</em>
                                                                </MenuItem>
                                                                <MenuItem value={'1'}>{staticText.package1Title}</MenuItem>
                                                                <MenuItem value={'2'}>{staticText.package2Title}</MenuItem>
                                                                <MenuItem value={'4'}>{staticText.package3Title}</MenuItem>
                                                            </Select>
                                                        </Box>
                                                    </Paper>
                                                )}
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Box evelotion={0} mt={2} className={classes.counterBox}>
                                                    <ButtonGroup className="counterBtns" size="small" aria-label="small outlined button group">
                                                        <Button disabled={true}>+</Button>
                                                        <Button disabled={true} style={{ marginLeft: '5px', marginRight: '5px' }}>1</Button>
                                                        <Button disabled={true}>-</Button>
                                                    </ButtonGroup>
                                                </Box>
                                            </Grid>
                                            {(lang === 'fa') && (
                                                <Grid item xs={12}>
                                                    <Paper>
                                                        <Box evelotion={0} mt={0}>
                                                            <Button type="button" style={{ display: (!showOutOfStockMSG) ? 'none' : 'block' }} disabled={true} variant="contained" color="primary" className={classes.buyButton + ' mt35'}>افزودن به سبد خرید</Button>
                                                        </Box>
                                                    </Paper>
                                                </Grid>
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            {(showOutOfStockMSG) ? (
                                                <>
                                                    <Grid item xs={6}>
                                                        {(productDetail.bulkSale) && (
                                                            <Paper evelotion={0} className={classes.noBgAndShdaw}>
                                                                <Box evelotion={0}>
                                                                    <Typography variant="h2" className={classes.selectWeight}>
                                                                        {staticText.selectWeight}
                                                                    </Typography>
                                                                    <Select
                                                                        value={'1'}
                                                                        disabled={true}
                                                                        displayEmpty
                                                                        className={classes.selectEmpty}
                                                                        inputProps={{ 'aria-label': 'Without label' }}>
                                                                        <MenuItem value={0}>
                                                                            <em>{staticText.selectWeight}</em>
                                                                        </MenuItem>
                                                                        <MenuItem value={'1'}>{staticText.package1Title}</MenuItem>
                                                                        <MenuItem value={'2'}>{staticText.package2Title}</MenuItem>
                                                                        <MenuItem value={'4'}>{staticText.package3Title}</MenuItem>
                                                                    </Select>
                                                                </Box>
                                                            </Paper>
                                                        )}
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <Box evelotion={0} mt={2} className={classes.counterBox}>
                                                            <ButtonGroup className="counterBtns" size="small" aria-label="small outlined button group">
                                                                <Button disabled={true}>+</Button>
                                                                <Button disabled={true} style={{ marginLeft: '5px', marginRight: '5px' }}>1</Button>
                                                                <Button disabled={true}>-</Button>
                                                            </ButtonGroup>
                                                        </Box>
                                                    </Grid>
                                                    {(lang === 'fa') && (
                                                        <Grid item xs={12}>
                                                            <Paper>
                                                                <Box evelotion={0} mt={0}>
                                                                    <Button type="button" style={{ display: (!showOutOfStockMSG) ? 'none' : 'block' }} disabled={true} variant="contained" color="primary" className={classes.buyButton + ' mt35'}>افزودن به سبد خرید</Button>
                                                                </Box>
                                                            </Paper>
                                                        </Grid>
                                                    )}
                                                </>
                                            ) : (
                                                <>
                                                    <Grid item xs={6}>
                                                        {(productDetail.bulkSale) && (
                                                            <Paper evelotion={0} className={classes.noBgAndShdaw}>
                                                                <Box evelotion={0}>
                                                                    <Typography variant="h2" className={classes.selectWeight}>
                                                                        {staticText.selectWeight}
                                                                    </Typography>
                                                                    <Select
                                                                        value={selectedWeight}
                                                                        onChange={
                                                                            (event) => {
                                                                                if (!loading) {
                                                                                    setSelectedWeight(event.target.value)
                                                                                    if (Number(event.target.value) === 1) {
                                                                                        if (Number(productDetail.numberInStock250) === 0) {
                                                                                            setShowOutOfStockMSG(true)
                                                                                        }
                                                                                        else {
                                                                                            setBtnPlusDisabled(false)
                                                                                            setBtnMinesDisabled(true)
                                                                                            setShowOutOfStockMSG(false)
                                                                                            setProductCount(1)
                                                                                            setTotalPrice(globalFuncs.SepratePrice(productDetail.price250))
                                                                                        }
                                                                                    }
                                                                                    else if (Number(event.target.value) === 2) {
                                                                                        if (Number(productDetail.numberInStock500) === 0) {
                                                                                            setShowOutOfStockMSG(true)
                                                                                        }
                                                                                        else {
                                                                                            setBtnPlusDisabled(false)
                                                                                            setBtnMinesDisabled(true)
                                                                                            setShowOutOfStockMSG(false)
                                                                                            setProductCount(1)
                                                                                            setTotalPrice(globalFuncs.SepratePrice(productDetail.price250 * 2))
                                                                                        }
                                                                                    }
                                                                                    else if (Number(event.target.value) === 4) {
                                                                                        if (Number(productDetail.numberInStock1000) === 0) {
                                                                                            setShowOutOfStockMSG(true)
                                                                                        }
                                                                                        else {
                                                                                            setBtnPlusDisabled(false)
                                                                                            setBtnMinesDisabled(true)
                                                                                            setShowOutOfStockMSG(false)
                                                                                            setProductCount(1)
                                                                                            setTotalPrice(globalFuncs.SepratePrice(productDetail.price250 * 4))
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                        displayEmpty
                                                                        className={classes.selectEmpty}
                                                                        inputProps={{ 'aria-label': 'Without label' }}>
                                                                        <MenuItem value={0}>
                                                                            <em>{staticText.selectWeight}</em>
                                                                        </MenuItem>
                                                                        <MenuItem value={'1'} disabled={outOfStock250}>{staticText.package1Title} {outOfStock250 && '(ناموجود)'}</MenuItem>
                                                                        <MenuItem value={'2'} disabled={outOfStock500}>{staticText.package2Title} {outOfStock500 && '(ناموجود)'}</MenuItem>
                                                                        <MenuItem value={'4'} disabled={outOfStock1000}>{staticText.package3Title} {outOfStock1000 && '(ناموجود)'}</MenuItem>
                                                                    </Select>
                                                                </Box>
                                                            </Paper>
                                                        )}
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <Box evelotion={0} mt={2} className={classes.counterBox}>

                                                            <Collapse in={showOutOfStockMSG}>

                                                                <Alert severity="info">
                                                                    {staticText.outOfStockSelectedWeight}
                                                                </Alert>

                                                            </Collapse>

                                                            <Collapse in={!showOutOfStockMSG}>

                                                                <ButtonGroup className="counterBtns" size="small" aria-label="small outlined button group">
                                                                    <Button disabled={btnPlusDisabled} onClick={() => {

                                                                        if (Number(selectedWeight) === 1) {
                                                                            if ((productCount + 1) <= productDetail.numberInStock250) {
                                                                                setTotalPrice(globalFuncs.SepratePrice(getPrice(1, false) * (productCount + 1)))
                                                                                setProductCount(productCount + 1)
                                                                                setBtnMinesDisabled(false)
                                                                            }
                                                                            else
                                                                                setBtnPlusDisabled(true)
                                                                        }
                                                                        else if (Number(selectedWeight) === 2) {
                                                                            if ((productCount + 1) <= productDetail.numberInStock500) {
                                                                                setTotalPrice(globalFuncs.SepratePrice(getPrice(2, false) * (productCount + 1)))
                                                                                setProductCount(productCount + 1)
                                                                                setBtnMinesDisabled(false)
                                                                            }
                                                                            else
                                                                                setBtnPlusDisabled(true)
                                                                        }
                                                                        else if (Number(selectedWeight) === 4) {
                                                                            if ((productCount + 1) <= productDetail.numberInStock1000) {
                                                                                setTotalPrice(globalFuncs.SepratePrice(getPrice(4, false) * (productCount + 1)))
                                                                                setProductCount(productCount + 1)
                                                                                setBtnMinesDisabled(false)
                                                                            }
                                                                            else
                                                                                setBtnPlusDisabled(true)
                                                                        }

                                                                    }}>+</Button>
                                                                    <Button disabled={false} style={{ marginLeft: '5px', marginRight: '5px' }}>{productCount}</Button>
                                                                    <Button disabled={btnMinesDisabled} onClick={() => {
                                                                        if ((productCount - 1) > 0) {
                                                                            setTotalPrice(globalFuncs.SepratePrice(getPrice(Number(selectedWeight), false) * (productCount - 1)))
                                                                            setProductCount(productCount - 1)
                                                                            setBtnPlusDisabled(false)
                                                                        }
                                                                        else
                                                                            setBtnMinesDisabled(true)
                                                                    }}>-</Button>
                                                                </ButtonGroup>

                                                            </Collapse>

                                                        </Box>
                                                    </Grid>
                                                    {(lang === 'fa') && (

                                                        <Grid item xs={12}>

                                                            <Paper>

                                                                <Box evelotion={0} mt={0}>

                                                                    <Button type="button" style={{ display: (showOutOfStockMSG) ? 'none' : 'block' }} disabled={addToCartIsDisabled} variant="contained" color="primary" onClick={() => { handleAddtoCart(productCount, selectedWeight) }} className={classes.buyButton + ' mt35'}>افزودن به سبد خرید</Button>
                                                                    <Button type="button" style={{ display: (!showOutOfStockMSG) ? 'none' : 'block' }} disabled={true} variant="contained" color="primary" className={classes.buyButton + ' mt35'}>افزودن به سبد خرید</Button>

                                                                </Box>

                                                            </Paper>

                                                        </Grid>

                                                    )}
                                                </>
                                            )}
                                        </>
                                    )}
                                </Hidden>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={5}>
                            <Paper className={classes.noBgAndShdaw}>
                                <Box evelotion={0} className={classes.properties}>
                                    {(loading) ? (
                                        <Skeleton animation="wave" style={{ width: '300px', height: '32px', marginBottom: '30px' }} />
                                    ) : (
                                        <Typography variant="h1" className={classes.propTitle}>
                                            {productDetail.propertiesTitle}
                                        </Typography>
                                    )}
                                    <Hidden only={['lg', 'md', 'sm']}>
                                        <hr style={{ color: '#ccc' }} />
                                    </Hidden>
                                    {loading
                                        ? numberLoader.map(() => (
                                            <>
                                                <Skeleton
                                                    variant="caption"
                                                    width={Math.random() * (101 - 30) + 30 + "%"}
                                                />
                                                <br />
                                            </>
                                        ))
                                        : (
                                            <>
                                                <Typography variant="p" className={classes.propContent}>
                                                    <div dangerouslySetInnerHTML={{ __html: productDetail.propertiesText }} />
                                                </Typography>
                                            </>
                                        )}
                                </Box>
                            </Paper>
                        </Grid>
                    </Grid>
                </Box>

            </Grid>

            <Grid item xs={12} style={{ marginTop: '25px' }}>
                <Paper elevation={0} className={classes.paperNoBg}>
                    <Box boxShadow={1} borderColor='#f2f2f2' border={1} borderRadius={16} className={classes.grayBox}>
                        <h2 className="smallTitle">{staticText.related}</h2>
                        <hr style={{ color: '#ccc' }} />
                        <div className="productsList related">
                            <ProductCarousel products={(!loading && typeof relatedProducts !== 'undefined') ? relatedProducts : []} lang={lang} loading={loading} key="carousel1" />
                        </div>
                    </Box>
                </Paper>
            </Grid>

            {(!cLoading && typeof comments !== "undefined") && (
                (userInfo.length !== 0) ? (
                    (userInfo.im) ? (
                        <CommentAreaAdmin cLoading={cLoading} cError={cError} comments={comments} refFunc={refreshComment} totalPages={totalPages} loggedIn={loggedIn} userInfo={userInfo} itemId={itemID} typeOfEntities="products" showStar={true} btnSendText='ثبت نظر و امتیاز' />
                    ) : (
                        <CommentArea cLoading={cLoading} cError={cError} comments={comments} totalPages={totalPages} loggedIn={loggedIn} userInfo={userInfo} itemId={itemID} typeOfEntities="products" showStar={true} btnSendText='ثبت نظر و امتیاز' />
                    )
                ) : (
                    <CommentArea cLoading={cLoading} cError={cError} comments={comments} totalPages={totalPages} loggedIn={loggedIn} userInfo={userInfo} itemId={itemID} typeOfEntities="products" showStar={true} btnSendText='ثبت نظر و امتیاز' />
                )
            )}

            <Snackbar
                open={alert.open}
                autoHideDuration={4000}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                onClose={toggleCloseAlert}>
                <Alert onClose={toggleCloseAlert} severity={alert.type}>
                    {alert.message}
                </Alert>
            </Snackbar>

            <Dialog
                fullWidth={true}
                maxWidth={isMobile ? 'sm' : 'xs'}
                open={open}
                TransitionComponent={Transition}
                onClose={handleClose}
                aria-labelledby="max-width-dialog-title"
                PaperProps={{
                    style: {
                        border: '1px solid #fff',
                    },
                }}>
                <TransformWrapper
                    defaultScale={1}
                    defaultPositionX={200}
                    defaultPositionY={100}>
                    {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                        <React.Fragment>
                            <Box textAlign="center">
                                <Button className="counterBtns" onClick={zoomIn}><ZoomInIcon /></Button>
                                <Button className="counterBtns" onClick={zoomOut}><ZoomOutIcon /></Button>
                                <Button className="counterBtns" onClick={resetTransform}><FindReplaceIcon /> </Button>
                            </Box>
                            <TransformComponent>
                                <img width="90%" style={{ margin: '0 auto' }} src={productDetail.imgURL} alt="test" />
                                <img
                                    style={{ margin: '-50px auto 0 auto' }}
                                    src="/images/home-page-header/logo.png"
                                    width="50px"
                                    height="30px"
                                />
                            </TransformComponent>
                        </React.Fragment>
                    )}
                </TransformWrapper>
            </Dialog>

            <ShareModal openShareModal={openShareModal} closeFunc={onCloseShareModal} shareBoxTitle={"محصولات ما را به اشتراک بگذارید."} title={productDetail.title} shareUrl={`https://ajilhassanpour.com/product/${productDetail.id}`} />

            <LoginModal open={isModalOpen} onClose={onClose} redirect={true} />

        </WideLayout >

    )
}

export default Product
